<!-- Define reusable ng-select template -->
<ng-template #ngSelectTemplate>
  <ng-select
    [items]="items"
    name="value"
    [bindLabel]="bindLabel"
    [placeholder]="
      placeholderKey ? (placeholderKey | localeTrans) : placeholder
    "
    [bindValue]="bindValue"
    [disabled]="readonly"
    [compareWith]="compareHandler"
    [(ngModel)]="value"
    [searchFn]="searchFn"
    (ngModelChange)="updateChanges()"
    (change)="handleChange()"
    [style]="style"
    [clearable]="clearable"
    [searchable]="searchable"
    [hideSelected]="hideSelected"
    [appendTo]="appendTo"
    [ngClass]="{
      'form-select form-select--light sv-dropdown--float':
        inputMode === 'float',
    }"
  >
    <ng-container *ngIf="labelTemplate">
      <ng-template ng-label-tmp let-item="item">
        <ng-template
          [ngTemplateOutlet]="labelTemplate"
          [ngTemplateOutletContext]="{ item: item }"
        >
        </ng-template>
      </ng-template>
    </ng-container>
  </ng-select>
</ng-template>

<!-- Main component rendering -->
<ng-container *ngIf="inputMode === 'float'; else defaultMode">
  <div class="form-group form-floating">
    <ng-container *ngTemplateOutlet="ngSelectTemplate"></ng-container>
    <label *ngIf="label" class="sv-float-label">{{ label }}</label>
  </div>
</ng-container>

<ng-template #defaultMode>
  <ng-container *ngTemplateOutlet="ngSelectTemplate"></ng-container>
</ng-template>
